import { ColumnFilterType, IndexedStrings } from '../SelectableTable.types';
import { Searchbar } from '../../Searchbar/Searchbar.component';

interface FilterCellProps {
  type: ColumnFilterType;
  name: string;
  filter?: IndexedStrings;
  filterElements?: { [key: string]: JSX.Element };
  tabIndex: number;
  onFilterChange?: (name: string, value: string) => void;
}

const FilterCell: React.FC<FilterCellProps> = (props) => {
  if (!props.filterElements || !props.filter || !props.onFilterChange) {
    return null;
  }
  return props.type === 'search' ? (
    <Searchbar
      name={props.name}
      handleSearchInput={props.onFilterChange}
      searchInput={props.filter[props.name] as string}
      noBorder
      tabIndex={props.tabIndex}
    />
  ) : (
    <>{props.filterElements[props.name]}</>
  );
};

export default FilterCell;
